import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ScheduleFormController extends Controller {
  static targets = [
    'shiftRow',
    'shiftCheckbox',
    'selectAll',
    'bulkStartsAt',
    'bulkEndsAt',
    'startsAtField',
    'endsAtField',
    'breakStartsAtField',
    'breakEndsAtField'
  ]

  toggle ({ target }) {
    const row = target.closest('tr')
    if (!row) return

    const checked = target.checked
    this.setRowEnabled(row, checked)
    this.syncSelectAll()
  }

  toggleAll () {
    const checked = this.selectAllTarget.checked

    this.shiftCheckboxTargets.forEach((cb, i) => {
      cb.checked = checked
      this.setRowEnabled(this.shiftRowTargets[i], checked)
    })
  }

  applyToAll () {
    const startsAt = this.bulkStartsAtTarget.value
    const endsAt = this.bulkEndsAtTarget.value

    this.shiftCheckboxTargets.forEach((cb, i) => {
      if (!cb.checked) return

      if (startsAt) this.startsAtFieldTargets[i].value = startsAt
      if (endsAt) this.endsAtFieldTargets[i].value = endsAt
    })
  }

  // private

  setRowEnabled (row, enabled) {
    row.classList.toggle('opacity-40', !enabled)

    const inputs = row.querySelectorAll('input[type="time"]')
    inputs.forEach(input => {
      input.disabled = !enabled
    })
  }

  syncSelectAll () {
    if (!this.hasSelectAllTarget) return

    const allChecked = this.shiftCheckboxTargets.every(cb => cb.checked)
    this.selectAllTarget.checked = allChecked
  }
}

stimulus.register('schedule-form', ScheduleFormController)
